module.exports = __webpack_public_path__ + "img/Fisherman1.png";